import React from 'react';
import { Mutation } from 'react-apollo';
import { MUTATION } from 'graphql/CreateUserProfileMutation';

import { func } from 'prop-types';

const CreateConfigMutation = props => (
  <Mutation mutation={MUTATION}>
    {(createUserProfileUser, { data }) => {
      return props.children(createUserProfileUser);
    }}
  </Mutation>
);

CreateConfigMutation.propTypes = {
  children: func.isRequired
};

export default CreateConfigMutation;
